import PreservedLink from '@/components/shared/PreservedLink'
import Logo from '@/components/shared/Logo'
import { footerData } from '@/shared/navigationData'

const ScrollToTopLink = ({ to, className, children, ...props }) => {
  const handleClick = () => {
    window.scrollTo(0, 0)
  }

  return (
    <PreservedLink
      to={to}
      className={className}
      onClick={handleClick}
      {...props}
    >
      {children}
    </PreservedLink>
  )
}

const MobileFooter = () => {
  return (
    <div className="block lg:hidden">
      <div className="container mx-auto max-w-[90%] py-8">
        <div className="mb-6 grid grid-cols-1 items-start gap-6 sm:mb-8 sm:grid-cols-2 sm:gap-8">
          <div className="flex flex-col items-center sm:items-start">
            <div className="mb-4 sm:mb-6">
              <Logo variant="footer" />
            </div>
          </div>

          <div className="text-center">
            <h3 className="mb-3 inline-block border-b border-[#F4A261] pb-2 text-base font-semibold text-white sm:mb-4 sm:text-lg">
              ADDRESS
            </h3>
            <div className="space-y-1 text-white">
              <p>Claims 1</p>
              <p className="font-raleway-numbers">84 Salop Street</p>
              <p>Wolverhampton</p>
              <p className="font-raleway-numbers">WV3 0SR</p>
            </div>
          </div>
        </div>

        <div className="mb-6 grid grid-cols-1 items-start gap-6 sm:mb-8 sm:grid-cols-2 sm:gap-8">
          <div className="text-center">
            <h3 className="mb-3 inline-block border-b border-[#F4A261] pb-2 text-base font-semibold text-white sm:mb-4 sm:text-lg">
              INFORMATION
            </h3>
            <ul className="space-y-1">
              <li>
                <ScrollToTopLink
                  className="flex min-h-[44px] touch-manipulation items-center justify-center py-2 text-white transition-colors hover:text-[#F4A261]"
                  to="/faqs"
                >
                  FAQs
                </ScrollToTopLink>
              </li>
              <li>
                <ScrollToTopLink
                  className="flex min-h-[44px] touch-manipulation items-center justify-center py-2 text-white transition-colors hover:text-[#F4A261]"
                  to="/about-us"
                >
                  About Us
                </ScrollToTopLink>
              </li>
              <li>
                <ScrollToTopLink
                  className="flex min-h-[44px] touch-manipulation items-center justify-center py-2 text-white transition-colors hover:text-[#F4A261]"
                  to="/contact"
                >
                  Contact Us
                </ScrollToTopLink>
              </li>
              <li>
                <ScrollToTopLink
                  className="flex min-h-[44px] touch-manipulation items-center justify-center py-2 text-white transition-colors hover:text-[#F4A261]"
                  to="/careers"
                >
                  Careers
                </ScrollToTopLink>
              </li>
              <li>
                <ScrollToTopLink
                  className="flex min-h-[44px] touch-manipulation items-center justify-center py-2 text-white transition-colors hover:text-[#F4A261]"
                  to="/mlm-information-and-key-facts"
                >
                  Key Facts
                </ScrollToTopLink>
              </li>
              <li>
                <ScrollToTopLink
                  className="flex min-h-[44px] touch-manipulation items-center justify-center py-2 text-white transition-colors hover:text-[#F4A261]"
                  to="/referral-program"
                >
                  Referral Program
                </ScrollToTopLink>
              </li>
            </ul>
          </div>

          <div className="text-center">
            <h3 className="mb-3 inline-block border-b border-[#F4A261] pb-2 text-base font-semibold text-white sm:mb-4 sm:text-lg">
              POLICIES
            </h3>
            <ul className="space-y-1">
              <li>
                <ScrollToTopLink
                  className="flex min-h-[44px] touch-manipulation items-center justify-center py-2 text-white transition-colors hover:text-[#F4A261]"
                  to="/terms-and-conditions"
                >
                  Terms and Conditions
                </ScrollToTopLink>
              </li>
              <li>
                <ScrollToTopLink
                  className="flex min-h-[44px] touch-manipulation items-center justify-center py-2 text-white transition-colors hover:text-[#F4A261]"
                  to="/privacy-policy"
                >
                  Privacy Policy
                </ScrollToTopLink>
              </li>
              <li>
                <ScrollToTopLink
                  className="flex min-h-[44px] touch-manipulation items-center justify-center py-2 text-white transition-colors hover:text-[#F4A261]"
                  to="/cookie-policy"
                >
                  Cookie Policy
                </ScrollToTopLink>
              </li>
              <li>
                <ScrollToTopLink
                  className="flex min-h-[44px] touch-manipulation items-center justify-center py-2 text-white transition-colors hover:text-[#F4A261]"
                  to="/terms-of-use"
                >
                  Terms of Use
                </ScrollToTopLink>
              </li>
              <li>
                <ScrollToTopLink
                  className="flex min-h-[44px] touch-manipulation items-center justify-center py-2 text-white transition-colors hover:text-[#F4A261]"
                  to="/complaints-procedure"
                >
                  Complaints Procedure
                </ScrollToTopLink>
              </li>
            </ul>
          </div>
        </div>

        <div>
          <div className="mb-6 space-y-4">
            {footerData.company.description
              .split('\n\n')
              .map((paragraph, index) => {
                if (paragraph.startsWith('Sources:')) {
                  return null
                }
                return (
                  <p
                    key={index}
                    className="text-xs leading-relaxed text-white/50"
                    dangerouslySetInnerHTML={{ __html: paragraph }}
                  />
                )
              })}
            {footerData.company.legalInfo && (
              <p className="text-xs leading-relaxed text-white/50">
                {footerData.company.legalInfo}
              </p>
            )}
          </div>

          <div className="pt-4">
            <div className="flex items-center justify-center">
              <div className="flex gap-3">
                {footerData.social.map(social => (
                  <a
                    key={social.title}
                    href={social.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-white/70 transition-colors hover:text-white"
                    aria-label={social.title}
                  >
                    {social.icon === 'facebook' && (
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z" />
                      </svg>
                    )}
                    {social.icon === 'instagram' && (
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <rect
                          width="20"
                          height="20"
                          x="2"
                          y="2"
                          rx="5"
                          ry="5"
                        />
                        <path d="m16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" />
                        <line x1="17.5" x2="17.51" y1="6.5" y2="6.5" />
                      </svg>
                    )}
                    {social.icon === 'tiktok' && (
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <path d="M9 12a4 4 0 1 0 4 4V4a5 5 0 0 0 5 5" />
                      </svg>
                    )}
                  </a>
                ))}
              </div>
            </div>

            <div className="mt-6 border-t border-white/20 pt-4">
              <p className="font-raleway-numbers mb-2 text-center text-xs text-white/50">
                Claims1 head office address: 84 Salop Street, Wolverhampton, WV3
                0SR, United Kingdom.
              </p>
              <p className="font-raleway-numbers mb-4 text-center text-xs text-white/50">
                Claims1 is a claims management company and is a trading style of
                Victor Hydon Ltd, Swinford House, Albion St, Brierley Hill DY5
                3EE and is registered in England and Wales (Company No 09086740)
                VAT registration number 204 1226 68. Victor Hydon Ltd is
                regulated by the Financial Conduct Authority (Firm reference
                number: 833758). These details can be confirmed by visiting the
                Financial Services Register, www.fca.org.uk/register.
              </p>
              <p className="font-raleway-numbers text-center text-xs text-white/70">
                Copyright 2026 Claims1. All rights reserved.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default MobileFooter
